<rb-auth-container [title]="(authError$ | async)
                             ? 'LOGIN.ERROR.TITLE'
                             : ((isAuthenticated$ | async) === true ? 'LOGIN.SUCCESS.TITLE' : 'AUTH.LOADING')">
  <ng-container *ngIf="(authError$ | async) as authError">
    <div class="flex flex-col items-center">
      <mat-icon class="icon-negative" svgIcon="error"></mat-icon>
    </div>
    <p class="text-center mt-[1rem]">{{ authError.message }}</p>
    <button (click)="login()"
            [disableRipple]="true"
            class="button-auth0 mt-[2.4rem] text-white w-full"
            mat-flat-button>{{ 'LOGIN.ERROR.BUTTON' | translate }}
    </button>
  </ng-container>
  <ng-container *ngIf="(authError$ | async) === null && (isAuthenticated$ | async) === true && officeId === null">
    <div class="flex flex-col items-center">
      <mat-icon class="icon-positive" svgIcon="check"></mat-icon>
    </div>
    <p class="text-center text-brand font-bold mt-[1rem]">
      <a routerLink="/">{{ 'LOGIN.SUCCESS.LINK' | translate }}</a>
    </p>
  </ng-container>
  <ng-container *ngIf="(authError$ | async) === null && ((isAuthenticated$ | async) !== true || officeId !== null)">
    <div class="flex flex-col items-center">
      <mat-spinner class="spinner-brand" diameter="20"></mat-spinner>
    </div>
  </ng-container>
</rb-auth-container>
